<template>
  <div>
    <!-- Inline -->
    <div class="row q-mb-md">
      <!-- Filters hide/show button -->
      <div class="col-6">
        <div class="row" style="justify-content: flex-start">
          <div>
            <q-btn
              @click="showFilters"
              :text-color="hideFilters ? 'grey-5' : 'white'"
              class="neutral-btn ctrl-button btn-compact"
              :class="{ primary: !hideFilters }"
              icon="filter_list"
              :icon-right="hideFilters ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
            />
          </div>
          <!-- Searchfield -->
          <div class="q-ml-md" style="flex-grow: 1">
            <q-input
              :disable="!hideFilters || activeFilters"
              color="grey-5"
              v-model="searchTerm"
              @input="applyFilters"
              :placeholder="getString('module.structure.list.filter.label')"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Filters block -->
    <transition name="fade">
    <div v-if="!hideFilters" class="table-block q-mb-md">
      <div class="row q-pa-md" style="justify-content: space-between;">
        <!-- Searchfield -->
        <div class="col-6 q-pa-md">
          <q-input color="primary"
            v-model="filters.code"
            @input="applyFilters"
            float-label="Code"/>
        </div>
        <!-- Searchfield -->
        <div class="col-6 q-pa-md">
          <q-input color="primary"
          v-model="filters.description"
          @input="applyFilters"
          :float-label="getString('description')"/>
        </div>
      </div>
      <div class="row q-pa-md" style="justify-content: space-between;">
        <!-- Checkbox active -->
        <q-checkbox
          class="select-text q-pa-md"
          :color="checkboxActive"
          toggle-indeterminate
          v-model="filters.active"
          @input="applyFilters"
          label="Active"
        />
        <div class="q-pa-md" style="vertical-align: middle;">
          <q-btn
            :disable="!activeFilters"
            @click="resetFilters()"
            class="capitalize ctrl-button"
            :color="activeFilters ? 'primary' : 'grey-4'"
            label="Reset"
          />
        </div>
      </div>
    </div>
    </transition>
    <table-overview
      :endpoint="'structure'"
      :responseFormat="'structures'"
      :columns="columns"
      :permission="'structure'"
      :module="'structure'"
      :selectable="false">
    </table-overview>
  </div>
</template>

<script>
import filtersMixin from '@/mixins/tables/filtersMixin';
import getString from '@/helpers/GetStrings';

// Components
import TableOverview from '@/components/overview/TableOverview.vue';

export default {
  data() {
    return {
      isLoading: false,
      filters: {
        code: '',
        description: '',
        active: null,
      },
      searchTerm: '',
      hideFilters: true,
      columns: [
        {
          name: '__slot:structure-code',
          title: 'Code',
          sortField: 'code',
          titleClass: 'text-left sortable vcol-m',
          dataClass: 'text-left vcol-m text-ellipsis',
        },
        {
          name: '__slot:structure-description',
          title: getString('description'),
          sortField: 'description',
          titleClass: 'text-left sortable vcol-l',
          dataClass: 'text-left vcol-l text-ellipsis',
        },
        // {
        //   name: '__slot:structure-active',
        //   title: getString('active'),
        //   sortField: 'active',
        //   titleClass: 'text-left sortable vcol-m',
        //   dataClass: 'text-left vcol-m text-ellipsis',
        // },
      ],
    };
  },
  mixins: [
    filtersMixin,
  ],
  components: {
    TableOverview,
  },
  methods: {
    getString,
  },
};
</script>
